import React from "react";
import { Card } from "@mui/material";
import { useState, useEffect } from "react";
import DataTable from "examples/Tables/DataTable";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import AccountingApi from "../../../Classes/API/AccountingApi";
import CreateDomesticExtraReq from "../../../Classes/Models/Requests/Accounting/CreateDomesticExtraReq";
import Swal from "sweetalert2";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import AddManyToManyReq from "../../../Classes/Models/Requests/AddManyToManyReq";

const PatientsTable = ({ Contract, setIsLoaded }) => {
  const TableColumns = [
    { Header: "Id", accessor: "Id", align: "left" },
    { Header: "Name", accessor: "Name", align: "left" },
    { Header: "Remove", accessor: "Remove", align: "left" },
  ];
  const [TableDataRows, setTableDataRows] = useState([]);

  const RemovePatient = async (patientId) => {
    const RemovePatientReq = new AddManyToManyReq();
    RemovePatientReq.Id1 = Contract.id;
    RemovePatientReq.Id2 = patientId;

    var res = await AccountingApi.RemovePatientFromContract(RemovePatientReq);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Patient Removed Successfully",
        icon: "success",
        confirmButtonText: "OK",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const MakeTableRow = (Patient) => {
    console.log(Patient);
    return {
      Id: (
        <MDTypography component="a" variant="button" color="text" fontWeight="medium">
          Patient Id: {Patient.id}, User Id: {Patient.getUser.id}
        </MDTypography>
      ),
      Name: (
        <MDTypography component="a" variant="button" color="text" fontWeight="medium">
          {Patient.getUser.name}
        </MDTypography>
      ),
      Remove: (
        <button className="btn btn-outline-danger" onClick={() => RemovePatient(Patient.id)}>
          X
        </button>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((Patient, index) => {
      rows.push(MakeTableRow(Patient, index));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    if (Contract.getContractPatients.length > 0) {
      RefreshTable(Contract.getContractPatients);
    } else {
      return (
        <MDTypography component="a" variant="button" color="text" fontWeight="medium">
          No Patients
        </MDTypography>
      );
    }
  }, [Contract]);

  return (
    <Card className="mt-5">
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          Contract Patients Table
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
    </Card>
  );
};

export default PatientsTable;
